import Vue from "vue";
import axios from "axios";
import moment from 'moment'
import store from '../store'
import router from '../router'
let backEndAPI = null;
// else firebase
backEndAPI = axios.create({
  baseURL: process.env.API_SERVER ? process.env.API_SERVER : 'http://localhost:3000',
  timeout: 50000
});

/**
 * 서버로 요청하기 전에 token 값을 항상 유지 한다.
 */
backEndAPI.interceptors.request.use(async (config) => {
  // Do something before request is sent
  if (store.state.auth && store.state.auth.user) {
    config.headers.common['Authorization'] = `${store.state.auth.user.tokenType} ${store.state.auth.user.accessToken}`;
  }
  return config;
}, function (error) {
  console.log(error);
  return Promise.reject(error);
});
/**
 * 응답처리...
 */
backEndAPI.interceptors.response.use((response) => { return response; },
  async (error) => {
    if (error.response && error.response.status === 401) { // 인증오류 발생
      console.log("401 url", error.response.config.url);
      if (error.response.config.url.indexOf("auth/refreshToken") > 0) {
        console.log("refresh fail.....")
        window.alert("인증이 만료되었습니다.\n다시 로그인을 해주시기 바랍니다.")
        store.dispatch("auth/signOut");
        router.push("/login");
        Promise.reject(error);
      }
      // console.log("send refresh....", error.response.config)
      let config = error.config;
      try {
        await store.dispatch("auth/refreshToken");
      } catch (e) {
        window.alert("인증이 만료되었습니다.\n다시 로그인을 해주시기 바랍니다.")
        store.dispatch("auth/signOut");
        router.push("/login");
        Promise.reject(error);
        return;
      }
      config.headers["Authorization"] = `${store.state.auth.user.tokenType} ${store.state.auth.user.accessToken}`;
      return await backEndAPI.request(error.response.config);
    }

    return Promise.reject(error);
  });
Vue.prototype.$axios = backEndAPI;

export default backEndAPI;



// WEBPACK FOOTER //
// ./src/plugins/axios.js